export const RUN_SAFE_VIDEO_COORDINATION_EVENT = 'run-safe-in-the-dark:video-coordination'

export type RunSafeVideoCoordinationDetail = {
  source: 'hero' | 'founder-said'
  active: boolean
}

export const dispatchRunSafeVideoCoordination = (
  detail: RunSafeVideoCoordinationDetail
) => {
  window.dispatchEvent(
    new CustomEvent<RunSafeVideoCoordinationDetail>(
      RUN_SAFE_VIDEO_COORDINATION_EVENT,
      { detail }
    )
  )
}
